import moment from "moment";
import {
  countWorkout,
  mapDaysOfTheWeek,
  combineDays,
} from "../body-composition.helper";
import SvgIcon from "../../../../../parts/SvgIcon";

const ThisWeekStats = ({
  athlete,
  activeExercises,
  startingCalendarDay = 0,
  organizationCoachParam,
}) => {
  const activeExercisesDays = activeExercises.length
    ? activeExercises.map(mapDaysOfTheWeek)
    : [];

  const revisedActiveExercises = combineDays(activeExercisesDays);

  const defaultWeekdays = Array.apply(null, Array(7)).map((_, i) => {
    return moment(i, "e")
      .startOf("week")
      .isoWeekday(i + startingCalendarDay)
      .format("ddd");
  });

  const completeDays = [];

  const mapDays = revisedActiveExercises.reduce((map, obj) => {
    map[obj.day] = obj.work;
    return map;
  }, {});

  for (let day of defaultWeekdays) {
    const work = mapDays[day] || "rest";
    completeDays.push({ day, work });
  }

  const workoutCount = countWorkout(completeDays);

  return (
    <article id="week-stats">
      <Header
        athlete={athlete}
        organizationCoachParam={organizationCoachParam}
      />
      <section>
        <Results workoutCount={workoutCount} />
        <WeekDisplay daysOfWeek={completeDays} />
      </section>
      <footer className="only-show-mobile">
        <a
          className="composition-see-more only-show-mobile"
          href={`/athlete-portal/calendar/?athlete=${athlete}${organizationCoachParam}`}
        >
          <span>See Calendar</span>
          <SvgIcon
            src="/img/new-icons/arrow-square-right-gradient.svg"
            noFilterOnLight={true}
          />
        </a>
      </footer>
    </article>
  );
};

const Header = ({ athlete, organizationCoachParam }) => (
  <header>
    <h4>Training for this week</h4>
    <a
      className="composition-see-more mobile-hidden"
      href={`/athlete-portal/calendar/?athlete=${athlete}${organizationCoachParam}`}
    >
      <span>See Calendar</span>
      <SvgIcon
        src="/img/new-icons/arrow-square-right-gradient.svg"
        noFilterOnLight={true}
      />
    </a>
  </header>
);

const Results = ({ workoutCount }) => {
  return (
    <div>
      <div>
        <h1>{workoutCount.completed}</h1>{" "}
        <p className="p4">Workout{getPlural(workoutCount.completed)}</p>
      </div>
      <div>
        <h1>{workoutCount.rest}</h1>{" "}
        <p className="p4">Rest Day{getPlural(workoutCount.rest)}</p>
      </div>
      <div>
        <h1>{workoutCount.missed}</h1>{" "}
        <p className="p4">Missed workout{getPlural(workoutCount.missed)}</p>
      </div>
    </div>
  );
};

const getPlural = (number) => {
  if (number !== 1) {
    return "s";
  }
};

const WeekDisplay = ({ daysOfWeek }) => (
  <ul>
    {daysOfWeek.map(({ day, work }, index) => (
      <li key={index}>
        <p className="p4">{day}</p>
        {chooseEllipse(work)}
      </li>
    ))}
  </ul>
);

const chooseEllipse = (dayWorkout) => {
  if (dayWorkout === "completed") {
    return <CheckEllipse />;
  } else if (dayWorkout === "missed") {
    return <ExclamationEllipse />;
  } else {
    return <RestEllipse />;
  }
};

const CheckEllipse = () => <SvgIcon src="/img/new-icons/check-gradient.svg" />;

const ExclamationEllipse = () => (
  <SvgIcon src="/img/new-icons/vuesax-linear-info-circle-red.svg" />
);

const RestEllipse = () => (
  <SvgIcon src="/img/svg/rest-icon.svg" className="rest" />
);

export default ThisWeekStats;
